import { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { EyeOff } from "lucide-react";
import { API } from "../../config";

export const useVinVisibility = (enabled = true) => {
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    axios.get(`${API}/admin/vin-decoder/visibility`)
      .then((r) => setState(r.data))
      .catch(() => setState({ enabled: false, visible: false }));
  }, [enabled]);
  return state;
};

export const VinDecoderGate = ({ children }) => {
  const vis = useVinVisibility();
  if (!vis) return null;
  if (!vis.visible) return <Navigate to="/admin" replace />;
  return (
    <>
      {!vis.enabled && (
        <div className="max-w-7xl mx-auto px-6 pt-6" data-testid="vin-disabled-superadmin-banner">
          <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 flex items-center gap-2 text-sm text-amber-100">
            <EyeOff size={16} className="text-amber-400" />
            <span><b>DISATTIVATO – visibile solo a te.</b> Admin, concessionari e venditori non vedono il VIN Decoder finché non lo riattivi con l'interruttore generale.</span>
          </div>
        </div>
      )}
      {children}
    </>
  );
};
